import type { Styles } from 'react-joyride-react-19'

/**
 * 🎨 ESTILOS PREMIUM PARA REACT-JOYRIDE
 * Baseado na documentação oficial: https://docs.react-joyride.com/styling
 */
export const joyrideStyles: Styles = {
  // ⚙️ Configurações gerais
  options: {
    primaryColor: '#A9744F', // Clay - cor primária da Keffe
    backgroundColor: '#ffffff', // Branco
    textColor: '#211500', // Espresso Brown
    overlayColor: 'rgba(0, 0, 0, 0.6)',
    arrowColor: '#ffffff',
    width: 480,
    zIndex: 1400, // Overlay base
  },
  
  // 🎭 Tooltip principal - SUPER ATRATIVO
  tooltip: {
    backgroundColor: '#ffffff',
    borderRadius: 20, // Mais arredondado e moderno
    border: '1px solid rgba(59, 130, 246, 0.2)', // Borda azul sutil
    boxShadow: `
      0 0 0 1px rgba(59, 130, 246, 0.05),
      0 8px 24px -4px rgba(0, 0, 0, 0.08),
      0 20px 40px -8px rgba(59, 130, 246, 0.12),
      0 32px 64px -12px rgba(139, 92, 246, 0.08)
    `, // Múltiplas sombras coloridas em camadas
    color: '#1f2937',
    fontSize: 15,
    fontFamily: 'system-ui, -apple-system, sans-serif',
    lineHeight: 1.6,
    maxWidth: 420,
    minWidth: 340,
    padding: 0,
    filter: 'drop-shadow(0 4px 8px rgba(59, 130, 246, 0.1))', // Drop shadow colorido
    zIndex: 1500,
    transform: 'translateZ(0)', // GPU acceleration
    backdropFilter: 'blur(8px) saturate(120%)', // Glass effect sutil
    WebkitBackdropFilter: 'blur(8px) saturate(120%)', // Safari
  },

  // 📦 Container do conteúdo
  tooltipContainer: {
    padding: 32,
    textAlign: 'left',
  },

  // 🎯 Título
  tooltipTitle: {
    color: '#1f2937',
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.3,
    margin: '0 0 16px 0',
  },

  // 📝 Conteúdo
  tooltipContent: {
    color: '#6b7280',
    fontSize: 15,
    lineHeight: 1.6,
    margin: '0 0 24px 0',
  },

  // 🦶 Footer
  tooltipFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    marginTop: 24,
    paddingTop: 20,
    borderTop: '1px solid #e5e7eb',
  },

  // 🚀 Botão próximo (primário) - SUPER ATRATIVO
  buttonNext: {
    background: 'linear-gradient(135deg, #3b82f6, #6366f1)', // Gradiente azul-roxo
    border: 'none',
    borderRadius: 12,
    color: '#ffffff',
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 600,
    padding: '12px 24px',
    minWidth: 120,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)', // Animação mais suave
    boxShadow: `
      0 0 0 1px rgba(59, 130, 246, 0.2),
      0 4px 12px rgba(59, 130, 246, 0.3),
      0 8px 24px rgba(99, 102, 241, 0.2)
    `, // Múltiplas sombras
    transform: 'translateY(0) scale(1)',
    position: 'relative',
    overflow: 'hidden',
  },

  // 🔙 Botão voltar - ELEGANTE
  buttonBack: {
    backgroundColor: '#f8fafc',
    border: '1px solid rgba(148, 163, 184, 0.3)',
    borderRadius: 12,
    color: '#475569',
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 500,
    padding: '12px 24px',
    minWidth: 120,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: `
      0 1px 3px rgba(0, 0, 0, 0.05),
      0 2px 8px rgba(148, 163, 184, 0.1)
    `,
    backdropFilter: 'blur(4px)',
    WebkitBackdropFilter: 'blur(4px)',
  },

  // ⏭️ Botão pular - DISCRETO MAS ELEGANTE
  buttonSkip: {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#94a3b8',
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: 500,
    padding: '8px 12px',
    borderRadius: 10,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
  },

  // ❌ Botão fechar
  buttonClose: {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#6b7280',
    cursor: 'pointer',
    fontSize: 16,
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 6,
    transition: 'all 0.2s ease',
  },

  // 🎯 Beacon (ponto de destaque) - SUPER CHAMATIVO
  beacon: {
    background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)', // Gradiente azul-roxo
    border: '2px solid rgba(255, 255, 255, 0.9)',
    borderRadius: '50%',
    height: 32,
    width: 32,
    position: 'relative',
    zIndex: 1300,
    boxShadow: `
      0 0 0 4px rgba(59, 130, 246, 0.15),
      0 0 0 8px rgba(139, 92, 246, 0.1),
      0 4px 12px rgba(59, 130, 246, 0.3),
      0 8px 24px rgba(139, 92, 246, 0.2)
    `, // Múltiplos anéis coloridos
    transform: 'scale(1)',
    filter: 'drop-shadow(0 2px 4px rgba(59, 130, 246, 0.3))',
  },

  // 💫 Interior do beacon
  beaconInner: {
    backgroundColor: '#ffffff',
    borderRadius: '50%',
    display: 'block',
    height: '50%',
    left: '50%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
  },

  // 🔦 Spotlight (destaque do elemento) - borda super destacada
  spotlight: {
    backgroundColor: 'transparent',
    borderRadius: 12,
    border: '4px solid #3b82f6', // Borda ainda mais grossa
    boxShadow: '0 0 0 6px rgba(59, 130, 246, 0.4), 0 0 0 10px rgba(59, 130, 246, 0.2), 0 0 30px rgba(59, 130, 246, 0.3)', // Múltiplas bordas + brilho
  },

  // 🌫️ Overlay - totalmente transparente mas habilitado
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0)', // Opacidade ZERO
    zIndex: 1400, // Abaixo do tooltip
  },
  
  // Propriedades obrigatórias para TypeScript
  beaconOuter: {
    border: '2px solid #ffffff',
    borderRadius: '50%',
    backgroundColor: 'transparent',
  },
  
  overlayLegacy: {
    backgroundColor: 'rgba(0, 0, 0, 0)', // Opacidade ZERO
    zIndex: 1400,
  },
  
  overlayLegacyCenter: {
    backgroundColor: 'transparent',
  },
  
  spotlightLegacy: {
    backgroundColor: 'transparent',
  },
  
  tooltipFooterSpacer: {
    flex: '1',
  },
}

/**
 * ⚙️ CONFIGURAÇÃO PADRÃO DO JOYRIDE
 */
export const defaultJoyrideConfig = {
  continuous: true,
  showProgress: true,
  showSkipButton: true,
  spotlightClicks: true,
  disableOverlay: false, // REABILITAR overlay - necessário para spotlight funcionar
  disableOverlayClose: true,
  hideCloseButton: false,
  placement: 'bottom' as const,
  
  // 🔦 Configurações de spotlight
  spotlightPadding: 20,
  offset: 12,
  scrollOffset: 100,
  disableScrolling: false,
  
  // 🌍 Localização em português
  locale: {
    back: 'Voltar',
    close: 'Fechar',
    last: 'Finalizar',
    next: 'Próximo',
    open: 'Abrir',
    skip: 'Pular tour',
  },
}

/**
 * 🎨 CSS ADICIONAL PARA ANIMAÇÕES E HOVER STATES
 */
export const joyrideCSS = `
  /* Animação do beacon */
  @keyframes joyride-beacon-pulse {
    0%, 100% { 
      transform: scale(1); 
      opacity: 1; 
    }
    50% { 
      transform: scale(1.1); 
      opacity: 0.8; 
    }
  }
  
  .react-joyride__beacon {
    animation: joyride-beacon-pulse 2s infinite;
  }
  
  /* Hover states para botões */
  .react-joyride__tooltip button:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }
  
  /* Responsividade */
  @media (max-width: 640px) {
    .react-joyride__tooltip {
      max-width: calc(100vw - 2rem) !important;
      margin: 1rem !important;
    }
  }
  
  /* CSS adicional já movido para globals.css */
`
